import ReactGA from "react-ga";

const UA = process.env.REACT_APP_GA_UA;
const isTracking = process.env.NODE_ENV === "production";

export const trackPageView = pathname => {
  if (!isTracking) return;
  ReactGA.initialize(UA);
  ReactGA.pageview(pathname);
};

export const trackChangeLanguage = newLanguage => {
  if (!isTracking) return;
  ReactGA.event({
    category: "User",
    action: "troca idioma - " + newLanguage
  });
};

export const trackEvent = action => {
  if (!isTracking) return;
  ReactGA.event({
    category: "User",
    action
  });
};
